import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import round from 'lodash/round';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

import SpecialFormattedNumber from 'Components/Utility/Price/SpecialFormattedNumber';

import 'Features/Bundle/components/PayWhatYouWant/CharityLeaderboard.scss';

export default function CharityLeaderboard({ charity }) {
  const leaders = get(charity, 'leaders', []);
  if (isEmpty(leaders)) return false;

  return (
    <section className="CharityLeaderboard">
      <h3 className="mb-3">
        <FormattedMessage id="CharityLeaderboard.title" defaultMessage="Top Contributor Leaderboard" />
      </h3>
      {leaders.map((leader, position) =>
        <div className="CharityLeaderboard__row">
          <div className="CharityLeaderboard__starNameContainer">
            <div className="CharityLeaderboard__starContainer">
              <div className="CharityLeaderboard__star">
                <FontAwesomeIcon icon={faStar} />
              </div>
              <div className="CharityLeaderboard__number">
                {position + 1}
              </div>
            </div>
            <div className="CharityLeaderboard__name">
              {leader.leaderboard_name}
            </div>
          </div>
          <div className="CharityLeaderboard__donation">
            <SpecialFormattedNumber
              value={round((get(leader, 'value', 0) / 100), 2)}
              currency={leader.currency}
            />
          </div>
        </div>,
      )}
    </section>
  );
}

CharityLeaderboard.propTypes = {
  charity: PropTypes.shape({}),
};

CharityLeaderboard.defaultProps = {
  charity: {},
};
